module.exports = __webpack_public_path__ + "overseer_frontend_mobile/img/header_gh.bb882fa0.png";